<ppl-icon
  [svgIcon]="iconName"
  width="14px"
  height="14px"
  pplPopover
  pplPopoverAlignStart
  [pplPopoverTooltip]="message"
  [pplPopoverDisabled]="!message"
  [pplPopoverTooltipDirection]="tooltipDirection"
  [pplPopoverTooltipPreserveWhitespace]="tooltipPreserveWhitespace"
  [pplPopoverTooltipType]="tooltipType"
  [pplPopoverTooltipHoverPreserve]="true"
  [style.display]="'block'"
  [fill]="fill">
</ppl-icon>
